import React from 'react';
import { Card, CardBody, CardHeader, Col, Row } from 'reactstrap';
import { H5, H6, P, Badges } from '../../../AbstractElements';
import { BuyNow, FullyComfortable, LastYearEarning, LatestSportsShoes, New, TopSellingProductTitle } from '../../../Constant';
import Img from '../../../Utils/Ratio';

import product1 from '../../../assets/images/dashboard-2/product/1.png';

import { Link } from 'react-router-dom';
import { FaShoppingBag } from 'react-icons/fa';
import { TopSellingProductList } from '../../../Data/DashBoard/Ecommerce/TopSelingProductList';

const TopSellingProduct = () => {
  return (
    <Col xxl='6' xl='7' className='box-col-70 xl-65'>
      <Card className='selling-product'>
        <CardHeader className='card-no-border d-flex justify-content-between'>
          <H5>{TopSellingProductTitle}</H5>
          <div className='center-content'>
            <P>{LastYearEarning}</P>
          </div>
        </CardHeader>
        <CardBody className='p-t-0'>
          <Row>
            <Col md='6' sm='6' className='ratio_100'>
              <div className='product-box'>
                <Badges color='primary' className='left-badge'>
                  {New}
                </Badges>
                <Badges color='secondary' className=' right-badge'>
                  -36%
                </Badges>
                <div className='img-wrraper'>
                  <Img className='img-fluid bg-img bg-img-cover' src={product1} alt='product' />
                </div>
                <div className='product-detail'>
                  <P>{FullyComfortable}</P>
                  <Link to={`${process.env.PUBLIC_URL}/ecommerce/product-page`}>
                    <H6>{LatestSportsShoes}</H6>
                  </Link>
                  <Link className='btn btn-primary d-inline-flex align-items-center' to={`${process.env.PUBLIC_URL}/ecommerce/product-page`}>
                    <span className='d-inline-flex'>
                      <FaShoppingBag />
                    </span>
                    {BuyNow}
                  </Link>
                </div>
              </div>
            </Col>
            <Col md='6' className='ratio_100'>
              <Row className='product-block'>
                {TopSellingProductList.map((item, i) => (
                  <Col key={i} xs='6'>
                    <div className='product-box'>
                      <Badges color='transparent' className='right-badge font-primary'>
                        -{item.disc}%
                      </Badges>
                      <div className='img-wrraper'>
                        <Img className='img-fluid bg-img bg-img-cover' src={item.image} alt='product' />
                      </div>
                      <div className='product-detail'>
                        <Link to={`${process.env.PUBLIC_URL}/ecommerce/product-page`}>
                          <H6>{item.title}</H6>
                        </Link>
                      </div>
                    </div>
                  </Col>
                ))}
              </Row>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Col>
  );
};

export default TopSellingProduct;
